module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_10X_DCIS.c7dff196.png";